import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { useShiftDisplay } from "@/hooks/useShiftDisplay";

interface Props {
  shifts: string[];
  selected: string[];
  onToggle: (shift: string) => void;
  /** Operaciones cuyo nombre de turno se muestra (las de los SVCs a la vista). */
  operationIds: number[];
}

export const ShiftPicker = ({ shifts, selected, onToggle, operationIds }: Props) => {
  const shiftDisplay = useShiftDisplay();
  return (
    <div className="mb-6">
      <Label className="block mb-3 text-lg font-medium">
        Seleccione los turnos
      </Label>
      <div className="grid grid-cols-1 gap-2">
        {shifts.map((shift) => (
          <label
            key={shift}
            className={`border-2 rounded-lg p-3 transition-colors cursor-pointer block ${
              selected.includes(shift)
                ? "border-primary bg-primary-soft"
                : "border-gray-200 hover:border-gray-300"
            }`}
          >
            <div className="flex items-center space-x-3">
              <Checkbox
                checked={selected.includes(shift)}
                onCheckedChange={() => onToggle(shift)}
                className="h-4 w-4"
              />
              <span className="font-medium" translate="no">{shiftDisplay.forOperations(shift, operationIds)}</span>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};
